import React from "react";
import MarkUnfinishedSvg from '@/assets/icons/mark-unfinished.svg?react';

interface MarkUnfinishedIconProps {
  size?: "xs" | "sm" | "md" | "lg";
  color?: string;
  className?: string;
}

const MarkUnfinishedIcon: React.FC<MarkUnfinishedIconProps> = ({
                                                             size = "md",
                                                             color = "currentColor",
                                                             className = "",
                                                           }) => {
  const sizeClasses = {
    xs: "w-4 h-4",
    sm: "w-5 h-5",
    md: "w-6 h-6",
    lg: "w-7 h-7",
  };

  return (
    <MarkUnfinishedSvg
      fill={color}
      className={`${sizeClasses[size]} ${className}`}
    />
  )
};

export default MarkUnfinishedIcon;